import React, { createContext, useContext, useCallback } from 'react';
import Shepherd, { StepOptions } from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';

interface TourContextType {
  startTour: (tourId: string, steps: StepOptions[], onComplete?: () => void) => void;
}

const TourContext = createContext<TourContextType | undefined>(undefined);

export const TourProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const startTour = useCallback((tourId: string, steps: StepOptions[], onComplete?: () => void) => {
    if (Shepherd.activeTour) {
      return;
    }

    const tour = new Shepherd.Tour({
      useModalOverlay: true,
      defaultStepOptions: {
        cancelIcon: {
          enabled: true
        },
        classes: 'shadow-md bg-white text-primary-std rounded-md',
        scrollTo: { behavior: 'smooth', block: 'center' }
      }
    });

    tour.addSteps(steps);

    tour.on('complete', () => {
      onComplete?.();
    });

    tour.on('cancel', () => {
      onComplete?.();
    });

    void tour.start();
  }, []);

  return (
    <TourContext.Provider value={{ startTour }}>
      {children}
    </TourContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useTourContext = () => {
  const context = useContext(TourContext);
  if (!context) {
    throw new Error('useTourContext must be used within a TourProvider');
  }
  return context;
};
